import React, { useRef } from 'react';
import { Button, Form } from 'react-bootstrap';
import './Contact.css';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

const Contact = () => {
    const sendMail = e => {
        e.preventDefault();
        // console.log(e.target.name.value);
        emailjs.sendForm('service_irihyvw', 'template_zdnoria', e.target, 'uugwHLhUpaaP2nMFx')
            .then((result) => {
                toast.success('Email sent');
            }, (error) => {
                toast.error(error.text);
            });
        e.target.reset();
    }

    return (
        <section className='container mt-5 pt-5 mb-5 overflow-hidden ' id='contact'>
            <h1 className='text-warning text-center'>Contact Me</h1>
            <div className="small-border mb-4"></div>
            <div className='row gx-5 gy-5'>
                <div className='col-12 col-sm-12 col-md-6 col-lg-4' data-aos="fade-right" data-aos-duration="2000">
                    <div className='shadow-lg p-3 mb-3 mx-auto widthforrespo' style={{ height: '150px' }}>
                        <div className='mt-4'>
                            <h3 className=' text-center' style={{ color: "khaki" }}>Email</h3>
                            <a href="mailto:sryaosikder@gmail.com" target={"_blank"} rel="noreferrer" className='text-center text-decoration-none' style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem", wordBreak: "break-all" }}> <p className='text-center'>sryaosikder@gmail.com</p> </a>


                        </div>
                    </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-4' data-aos="fade-up" data-aos-duration="2000">
                    <div className='shadow-lg p-3 mb-3 mx-auto widthforrespo' style={{ height: '150px' }}>
                        <div className='mt-4'>

                            <h3 className='text-center' style={{ color: "khaki" }}>Phone</h3>
                            <a href="tel:+8801873943047" target={"_blank"} rel="noreferrer" className='text-center text-decoration-none' style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem", wordBreak: "break-all" }}> <p className='text-center'>+8801873943047</p> </a>


                        </div>
                    </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-4' data-aos="fade-left" data-aos-duration="2000">
                    <div className='shadow-lg p-3 mb-3 mx-auto widthforrespo' style={{ height: '150px' }}>
                        <div className='mt-4'>

                            <h3 className='text-center' style={{ color: "khaki" }}>LinkedIn</h3>
                            <a href="https://www.linkedin.com/in/srayo-sikder/" target={"_blank"} rel="noreferrer" className='text-center text-decoration-none' style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem", wordBreak: "break-all" }}> <p className='text-center'>https://www.linkedin.com/in/srayo-sikder</p></a>

                        </div>
                    </div>
                </div>
            </div>
            <div className='text-center mt-5 pt-3'>
                <form onSubmit={sendMail}>
                    <input type="text" name='name' className='w-75 pt-3 pb-3  mt-3 mb-3 rounded border-0 bg-dark bg-gradient p-2  text-white widhtforrespdefault' placeholder='Your name' required /> <br />
                    <input type="email" name='email' className='w-75 pt-3 pb-3  mt-3 mb-3 rounded border-0 bg-dark bg-gradient p-2  text-white widhtforrespdefault' placeholder='Your Email' required /> <br />
                    <input type="text" name='subject' className='w-75 pt-3 pb-3  mt-3 mb-3 rounded border-0 bg-dark bg-gradient p-2  text-white widhtforrespdefault' placeholder='Subject' required /> <br />
                    <textarea type="text" name='message' className='w-75 mb-4 pt-3 widhtforrespdefault rounded border-0 bg-dark bg-gradient p-2  text-white' placeholder='Message' style={{ height: '120px' }} required /> <br />
                    <button className='button-metamask px-4' type='submit'>Send Message</button>
                </form>
            </div>
        </section>
    );
};

export default Contact;